"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-1y0828q-0"
})(["display:inline-block;width:24px;height:24px;", " svg{vertical-align:text-bottom;fill:", ";width:100%;height:100%;}"], function (p) {
  return p.hasText && "\n    width: 16px;\n    height: 16px;\n  ";
}, (0, _helpers.color)('white'));

var _default = IconContainer;
exports.default = _default;